// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3ui7G","header":"ReportDetails_header__3DQO3","title":"ReportDetails_title__3DrnY","left":"ReportDetails_left__v2Uxw"};